<template>
    <div>
        <a-table :columns="columns" 
                 :data-source="products" 
                 :pagination="{pageSize: pageSize}"
                 rowKey="itemId"
        >
            <template slot="index" slot-scope="text, record, index">
                <p>{{ index + 1 }}</p>
            </template>

            <template slot="image" slot-scope="record">
                <h6 class="m-0">
					<a-avatar :size="48" shape="square" :src="record.imageUrl" class="mr-10"></a-avatar>
				</h6>
            </template>

            <template slot="status" slot-scope="text, record, index">
                <h6 class="m-0">
					<a-tag v-if="!record.isOutOfStock" color="success" class="ant-tag-success font-bold">
                        IN STOCK
                    </a-tag>
                    <a-tag v-else color="red" class="ant-tag-danger font-bold">
                        SOLD OUT
                    </a-tag>
				</h6>
            </template>
            <template slot="discount" slot-scope="text, record, index">
                <h6 class="m-0">
					<a-tag v-if="record.discount > 0.0" color="red" class="ant-tag-success font-bold">
                        {{ record.discount }}%
                    </a-tag>
                    <a-tag v-else color="green" class="ant-tag-success font-bold">
                        {{ record.discount }}%
                    </a-tag>
				</h6>
            </template>

            <template slot="actions" slot-scope="record">
				<a-button-group>

                    <a-popconfirm placement="topLeft" ok-text="Yes" cancel-text="No" @confirm="handleProductStatusOk(record)">
                        <template slot="title">
                            <p>Do you want to update product status?</p>
                        </template>
					    <a-button shape="circle" icon="form" size="small"/>
                    </a-popconfirm>

                    <a-popconfirm ok-text="Update"
                        placement="topLeft"
                      @confirm="handleProductDiscountOk(record)"
                    >
                        <template slot="title">
                            <a-input-number 
                                :min="0" 
                                :max="100"
                                :formatter="value => `${value}%`"
                                :parser="value => value.replace('%', '')"
                                v-model="discount"
                                @onChange="handleDiscountValueOnChange"
                            />	
                        </template>
                        	
                        <a-button shape="circle" icon="money-collect" size="small" />
                    </a-popconfirm>
				</a-button-group>
			</template>

        </a-table>
    </div>
</template>

<script>
import EditProductDiscountPopover from '../../../components/popovers/EditProductDiscountPopover.vue';
export default {
    props : {
        products : {type: Array}
    },
    components : {
        EditProductDiscountPopover
    },
    data () {
        return {
            discount : null,
            pageSize: 5, 
            columns : [
                {
					title: '#',
					dataIndex: 'index',
                    scopedSlots: { customRender: 'index' },
				},
                {
			        title : '',
			        scopedSlots : { customRender: 'image'},
		        },
                {
					title: 'PRODUCT',
					dataIndex: 'itemName',
				},
                {
					title: 'CATEGORY',
					dataIndex: 'category',
				},
                {
					title: 'PRICE',
					dataIndex: 'originalPrice',
				},
                {
					title: 'STATUS',
					dataIndex: 'isOutOfStock',
                    scopedSlots : { customRender: 'status'},
				},
                {
					title: 'DISCOUNT',
					dataIndex: 'discount',
                    scopedSlots : { customRender: 'discount'},
				},
                {
			        title : 'ACTIONS',
			        scopedSlots : { customRender: 'actions'},
			        fixed: 'right'
		        }
            ]
        }
    },
    computed : {
        
    },

    methods : {
        
        handleBtnProductStatus(record) {
            
            
            // this.$confirm( {
            //     title : title,
            //     content : 'Update product to ' + content,
            //     onOk() {
            //         updateProductStatus();
            //     },
            //     onCancel() {
            //         console.log('OnOK')
            //     }
            // })
        },


        async handleProductStatusOk(record) {
            
            let statusToUpdate = !record.isOutOfStock;
            this.$message.loading('Updating data...', 0);
            await this.$store.dispatch('products/updateProductStatus', {'itemId' : record.itemId, 'isOutOfStock' : statusToUpdate});
            await this.sleep(1000);
            this.$message.destroy();

        },

        handleProductStatusCancel() {
            this.discount = null;
        },

        async handleProductDiscountOk(record) {
            this.$message.loading('Updating data...', 0);
            console.log('handleProductDiscountOk:' + this.discount)
            await this.$store.dispatch('products/updateProductDiscount', {'itemId' : record.itemId, 'discount' : this.discount });
            this.discount = null;
            await this.sleep(1000);
            this.$message.destroy();
        },

        handleProductDiscountCancel(record) {

        },

        handleDiscountValueOnChange(value) {
            console.log('handleDiscountValueOnChange: ' + value)
            this.discount = value;
        },

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    }

}
</script>